import React, { Fragment } from "react";
import { ApiResult } from "../../lib/CmsApi";
import ProgramGrid from "../program/ProgramGrid";
import SectionList from "../sections/SectionList";
import IntroHeader from "../IntroHeader";
import Content from "../common/Content";
import Contacts from "../sections/Contacts";
import MagazineTeaserSection from "../sections/MagazineTeaserSection";
import EventSliderSection from "../sections/EventSlider";
import CustomPageHead from "../common/CustomPageHead";

type Category = ApiResult<"loadCategoryBySlug">;
type Events = ApiResult<"listExternalEvents">["items"];

export type Props = Category & {
  events?: Events;
  portraits?: ApiResult<"listMagazinPortraits">;
  news?: ApiResult<"listMagazinNews">;
};
export default function CategoryPage(props: Props) {
  const { programs, categoryCluster } = props as any; //TODO: FIX ANY
  return (
    <Fragment>
      <CustomPageHead
        title={props.name}
        desc={props.subheader && props.subheader.intro}
        seo={props.seo}
      />
      <IntroHeader
        headline={props.name}
        {...props.subheader}
        breadCrumpPath={[
          {
            title: categoryCluster.segment.name,
            route: "segment",
            params: { segment: categoryCluster.segment.slug }
          },
          {
            title: categoryCluster.name,
            route: "categoryCluster",
            params: {
              segment: categoryCluster.segment.slug,
              categoryCluster: categoryCluster.slug
            }
          },
          {
            title: props.name,
            route: "category",
            params: {
              segment: categoryCluster.segment.slug,
              categoryCluster: categoryCluster.slug,
              category: props.slug
            }
          }
        ]}
      />
      <main>
        <Content padded bottomMargin relative>
          <ProgramGrid
            headlineLevel={2}
            programs={programs.map(p => {
              const external = p._content === "externalProgram";
              return {
                label: p.type.name,
                headline: p.name,
                abstract: p.abstract,
                keyFacts: p.keyFacts,
                ctaHref: external ? p.ctaHref : undefined,
                ctaLabel: external ? p.ctaLabel : "Mehr erfahren",
                route: external ? undefined : "program",
                params: external
                  ? undefined
                  : {
                      segment: categoryCluster.segment.slug,
                      categoryCluster: categoryCluster.slug,
                      category: props.slug,
                      slug: p.slug
                    },
                external
              };
            })}
          />
        </Content>
        <SectionList sections={props.contents} />
        <Contacts
          headline="Wir sind für Sie da:"
          copy={`Wir beantworten Ihnen gerne Fragen zur Förderung für den Bereich „${props.name}“ und informieren Sie über die Angebote der IFB Hamburg.`}
          contacts={props.contacts}
          ariaLabel={`Ansprechpartner für den Bereich ${props.name}`}
        />
      </main>
      <aside>
        {props.events.length > 0 && (
          <EventSliderSection
            events={props.events}
            sectionProps={{ inSectionList: true }}
          />
        )}
        <MagazineTeaserSection
          overline={props.name}
          portraits={props.portraits}
          news={props.news}
          sectionProps={{ inSectionList: true }}
        />
      </aside>
    </Fragment>
  );
}

CategoryPage.getImages = (props: Props) => {
  let images = [];
  images = images.concat(IntroHeader.getImages(props.subheader));
  images = images.concat(Contacts.getImages({ contacts: props.contacts }));
  images = images.concat(
    MagazineTeaserSection.getImages({
      portraits: props.portraits,
      news: props.news
    })
  );
  return images;
};
